'use client';

import { useTranslations } from 'next-intl';

type CounterBadgeProps = {
  count?: number;
  className?: string;
  max?: number;
};

export const CounterBadge = ({ count, className, max = 99 }: CounterBadgeProps) => {
  const t = useTranslations('Cart');

  if (!count || count <= 0) return null;

  const displayValue = count > max ? `${max}+` : count;

  return (
    <span
      className={`bg-primary absolute -top-1 -right-0 flex min-h-[20px] min-w-[20px] items-center justify-center rounded-full border-2 border-white px-1 font-sans text-[10px] leading-none font-bold text-white ${className ?? ''} `}
      aria-label={t('itemCountBadgeLabel', { itemCount: count })}
    >
      {displayValue}
    </span>
  );
};
